import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { CircularProgress } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-enterprise";
import { useEffect, useState } from "react";

type Props = EditableCallbackParams;

export const DocumentNameColumn = ({ data }: Props) => {
	const [documentPicked, setDocumentPicked] = useState("");
	const [changeDocumentPicked, setChangeDocumentPicked] =
		useState<boolean>(false);

	const {
		state: {
			listAllDocuments,
			documentSearch,
			showListOfDocuments,
			loaderListSearchDocuments,
		},
		actions: {
			setShowListOfDocuments,
			setDocumentSearch,
			setDataDocumentSelected,
		},
	} = useAssetDetailsContext();

	const handleSearchDocumentChange = (e: any) => {
		setDocumentPicked(e.target.value.toUpperCase());
		setDocumentSearch(e.target.value.toUpperCase());
	};

	const handleDocumentSelected = (e: any) => {
		setDocumentPicked(e.target.innerText.trim().toUpperCase());
		setChangeDocumentPicked((prev: boolean) => !prev);
		setTimeout(() => {
			setShowListOfDocuments(false);
		}, 100);
	};

	useEffect(() => {
		if (documentPicked)
			setDataDocumentSelected(listAllDocuments[documentPicked]);
	}, [documentPicked, changeDocumentPicked]);

	if (data.id === -1) {
		return (
			<Grid2
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 148,
						maxWidth: 148,
						marginRight: "10px",
					}}
					value={documentPicked}
					onChange={handleSearchDocumentChange}
					autoFocus
					autoComplete="false"
				/>
				{showListOfDocuments && (
					<Grid2
						style={{
							maxHeight: "80px",
							overflowY: "scroll",
							scrollbarWidth: "thin",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							style={{
								width: 148,
								background: "rgb(248,248,248)",
								fontWeight: 500,
								textAlign: "center",
								border: "green",
								margin: "1px 0",
								outline: "none",
							}}
						>
							{loaderListSearchDocuments ? (
								<div
									style={{
										height: "80px",
										justifyContent: "center",
										alignItems: "center",
										display: "flex",
									}}
								>
									<CircularProgress size="1rem" />
								</div>
							) : (
								Object.values(listAllDocuments).map((document: any) => {
									if (
										document.DocumentName?.includes(
											documentSearch.toUpperCase(),
										)
									) {
										return (
											<div
												key={`document${document.DocumentName}`}
												style={{
													width: 148,
													height: 20,
													fontWeight: 500,
													textAlign: "center",
													cursor: "pointer",
												}}
												onClick={handleDocumentSelected}
											>
												<p style={{ textAlign: "center" }}>
													{document.DocumentName}
												</p>
											</div>
										);
									}
								})
							)}
						</Grid2>
					</Grid2>
				)}
			</Grid2>
		);
	} else return data?.DocumentName;
};
